//cspell:disable
export const excludedDomains = [
  'gmail',
  'gamil',
  'gmai',
  'gemail',
  'gimail',
  'gmil',
  'gmli',
  'gmaio',
  'gmali',
  'gmsil',
  'googlemail',
  'outlook',
  'hotmail',
  'live',
  'msn',
  'yahoo',
  'ymail',
  'rocketmail',
  'icloud',
  'me',
  'mac',
  'aol',
  'proton',
  'protonmail',
  'zoho',
  'gmx',
  'gmx',
  'mail',
  // 'email', // TODO: handle TLDs, eg: test@subDom.domain.com, if subdom is mail
  'usa',
  'consultant',
  'yandex',
  'yandex',
  'fastmail',
  'terra',
];
